import {type StateRoot} from '@/state'
import {readonly} from "vue";
import {webSocketSubscribe} from "@/keys";
import cleanAssign from "@/clean-assign";
import {log} from "@hantera/portal-app";

export default function (state: StateRoot) {
  webSocketSubscribe(message => {
    if (message.type === 'graphMetaModelUpdated') {
      cleanAssign(state.graphMetaModel, message.nodes);

      log.debug("graphMeta updated");
    }
  });
  
  return readonly(state.graphMetaModel);
}